export default {
    event_create_success_message: "Se ha creado el evento",
    event_create_title: "Crear evento",
    event_edit_success_message: "El evento ha sido editado",
    event_edit_title: "Editar Fabricante",
    event_name: "Nombre",
    event_status: "Estado",
    event_active: "Activo",
    event_inactive: "Inactivo",
    event_diagnostic: "Diagnóstico",
    event_tab_general: "General",
    event_tab_unit_type_event: "Typo de Evento de Unidad"
}